// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Users Area
export class AreaBrands {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Read
    /** Fetches all remote brands in the version
     * @param from - Remote version to fetch from
     * @returns All brands in the specified version
     */
    async getBrands(from) {
        return this.dataCore.getBrands(from.designSystemId, from.versionId);
    }
    /** Fetches a single brand
     * @param from - Remote brand to fetch from
     * @returns Brand in the specified version
     */
    async getBrand(from) {
        return this.dataCore.getBrand(from.designSystemId, from.versionId, from.brandId);
    }
    /** Creates new brand and retrieves the newly created brand object.
     * @param from - Remote brand to fetch from
     * @param model - new brand model
     * @returns Newly created brand object
     */
    async createBrand(from, model) {
        return this.dataCore.createBrand(from.designSystemId, from.versionId, model);
    }
    /** Edits brand
     * @param from - Remote brand to fetch from
     * @param model - new version model
     * @returns nothing
     */
    async editBrand(from, brand) {
        await this.dataCore.editBrand(from.designSystemId, from.versionId, from.brandId, brand);
    }
    /** Deletes brand
     * @param from - Remote brand to fetch from
     * @returns nothing
     */
    async deleteBrand(from) {
        await this.dataCore.deleteBrand(from.designSystemId, from.versionId, from.brandId);
    }
}
